/// <amd-module name="Build/Admin/Agent/Components/CapabilitiesList" />
import * as React from "react";

import { ObservableValue } from "VSS/Core/Observable";

import { Button } from "VSSUI/Button";
import { Table, ITableColumn, SimpleTableCell, TableColumnStyle, TableCell } from "VSSUI/Table";
import { Tooltip } from "VSSUI/ToolTipEx";
import { ArrayItemProvider } from "VSSUI/Utilities/Provider";

import * as Resources from "Build/Admin/Agent/Resources";

export interface ICapabilitiesListProps {
    capabilities: AgentCapability[];
    onCapabilityDeleted?(capability: AgentCapability): void;
}

export interface AgentCapability {
    name: string;
    value: string;
}

export class CapabilitiesList extends React.PureComponent<ICapabilitiesListProps> {
    constructor(props: ICapabilitiesListProps) {
        super(props);
    }

    public render(): JSX.Element {
        return (
            <Table<AgentCapability>
                className="pipelines-agent-capabilities-list"
                columns={this._getColumns()}
                itemProvider={new ArrayItemProvider<AgentCapability>(this.props.capabilities)}
            />
        );
    }

    private _getColumns(): ITableColumn<AgentCapability>[] {
        return [
            {
                id: "name",
                name: Resources.Name,
                width: new ObservableValue(-40),
                columnStyle: TableColumnStyle.Primary,
                renderCell: this._renderNameCell
            },
            {
                id: "value",
                name: Resources.Value,
                width: new ObservableValue(-60),
                columnStyle: TableColumnStyle.Secondary,
                renderCell: this._renderValueCell
            },
            {
                id: "delete",
                width: new ObservableValue(40),
                columnStyle: TableColumnStyle.Tertiary,
                renderCell: this._renderDeleteCell
            }
        ];
    }

    private _renderNameCell = (rowIndex: number, columnIndex: number, tableColumn: ITableColumn<AgentCapability>, tableItem: AgentCapability): JSX.Element => {
        return (
            <SimpleTableCell contentClassName="fontWeightSemiBold" columnIndex={columnIndex} tableColumn={tableColumn} key={"col-" + columnIndex}>
                <Tooltip overflowOnly={true}>
                    <span className="text-ellipsis bolt-list-cell-text">
                        {tableItem.name}
                    </span>
                </Tooltip>
            </SimpleTableCell>
        );
    }

    private _renderValueCell = (rowIndex: number, columnIndex: number, tableColumn: ITableColumn<AgentCapability>, tableItem: AgentCapability): JSX.Element => {
        return (
            <SimpleTableCell columnIndex={columnIndex} tableColumn={tableColumn} key={"col-" + columnIndex}>
                <Tooltip overflowOnly={true}>
                    <span className="text-ellipsis bolt-list-cell-text">
                        {tableItem.value}
                    </span>
                </Tooltip>
            </SimpleTableCell>
        );
    }

    private _renderDeleteCell = (rowIndex: number, columnIndex: number, tableColumn: ITableColumn<AgentCapability>, tableItem: AgentCapability): JSX.Element => {
        return (
            <TableCell className="bolt-table-cell-side-action" columnIndex={columnIndex} tableColumn={tableColumn} key={"col-" + columnIndex}>
                {
                    this.props.onCapabilityDeleted !== undefined &&
                    <div className="flex-column">
                        <Button
                            ariaLabel={Resources.Delete}
                            className="bolt-table-cell-content-reveal"
                            subtle={true}
                            excludeTabStop={true}
                            iconProps={{
                                iconName: "Delete",
                                className: "fontSizeML"
                            }}
                            onClick={e => {
                                if (this.props.onCapabilityDeleted !== undefined) {
                                    this.props.onCapabilityDeleted(tableItem);
                                }
                                e.preventDefault();
                            }}
                        />
                    </div>
                }
            </TableCell>
        );
    }
}
